<template>
  <v-layout row class="ml-2">
    <div v-if="getUser.pref.select.cauth !== null &&
    getUser.pref.select.fauth !== null"
    :class="ui.responseHideXs">
    <div :class="ui.textSubheading"> {{subtitle}} </div>
    </div>
    <div v-if="getUser.pref.select.cauth === null" :class="ui.responseHideXs">
      <v-chip small :class="ui.bkgdColor">
        <v-icon left :color="ui.colorWarning">warning</v-icon>
        <div :class="ui.textWarning"> Company </div>
      </v-chip>
    </div>
    <div v-if="getUser.pref.select.fauth === null && userOK" :class="ui.responseHideXs">
      <v-chip small :class="ui.bkgdColor">
        <v-icon left :color="ui.colorWarning">warning</v-icon>
        <div :class="ui.textWarning"> Facility </div>
      </v-chip>
    </div>
    <div v-if="!userOK" :class="ui.responseHideXs">
      <v-chip small :class="ui.bkgdColor">
        <v-icon left :color="ui.colorError">person</v-icon>
        <div :class="ui.textError"> Not Ready </div>
      </v-chip>
    </div>
    <div v-if="getUser.pref.select.cauth === null && licenceOK && userOK"
    :class="ui.responseShowXs">
      <v-chip :class="ui.bkgdColor">
        <v-icon left :color="ui.colorWarning">account_balance</v-icon>
      </v-chip>
    </div>
    <div v-if="getUser.pref.select.fauth === null && licenceOK && userOK" :class="ui.responseShowXs">
      <v-chip :class="ui.bkgdColor">
        <v-icon left :color="ui.colorWarning">place</v-icon>
      </v-chip>
    </div>
    <div v-if="!userOK"
    :class="ui.responseShowXs">
      <v-chip :class="ui.bkgdColor">
        <v-icon left :color="ui.colorError">person</v-icon>
      </v-chip>
    </div>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument.js";

export default {
  mixins: [apptheme, licenceFunctions, adminFunctions, describeDocument],
  computed: {
    ...mapGetters([
      "getUser",
      "getCurrentPage",
      "getSearchResults",
      "getRegisterInfo"
    ]),
    subtitle() {
      let title = "Register";
      if (this.getCurrentPage === "/treeview") {
        title = "Asset Strcuture";
      }
      // if (this.getCurrentPage === "/registerlist") {
      //   if (this.getSearchResults !== null) {
      //     let tag = this.getSearchResults[0].basic.tag;
      //     title = this.defineDocumentFromTag(tag).titles + " Register";
      //   }
      // }
      if (this.getCurrentPage === "/userdetail") {
        title = "Settings and Preferences";
      }
      if (this.getCurrentPage === "/companydetail") {
        title = "Strategy and Systems";
      }
      if (this.getCurrentPage === "/facilitydetail") {
        title = "Operations and Maintenance";
      }
      if (this.getCurrentPage === "/opsdetail") {
        title = "Observations and Routines";
      }
      if (this.getCurrentPage === "/equipmentdetail") {
        title = "Technical Specifications";
      }
      if (this.getCurrentPage === "/assetdetail") {
        title = "Operational Management";
      }
      if (this.getCurrentPage === "/incidentdetail") {
        title = "Event Investigation";
      }
      if (this.getCurrentPage === "/appdash") {
        title = "Main Dashboard";
      }
      if (this.getCurrentPage === "/accesslist") {
        title = "Access Register";
      }
      if (this.getCurrentPage === "/activitylog") {
        title = "Time Log";
      }
      if (this.getCurrentPage === "/userdash") {
        title = "User Dashboard";
      }
      if (this.getCurrentPage === "/userdash") {
        title = "User Dashboard";
      }
      if (this.getCurrentPage === "/usermanagement") {
        title = "User Activity";
      }
      if (this.getCurrentPage === "/facilitymanagement") {
        title = "Facility Management";
      }
      if (this.getCurrentPage === "/facilitydash") {
        title = "Facility Dashboard";
      }
      if (this.getCurrentPage === "/budgetdetail") {
        title = "Budget Detail";
      }
      if (this.getCurrentPage === "/maintstrategydetail") {
        title = "Maintenance Strategy";
      }
      if (this.getCurrentPage === "/materialdetail") {
        title = "Order Transport Storage";
      }
      if (this.getCurrentPage === "/proceduredetail") {
        title = "Procedure Detail";
      }
      if (this.getCurrentPage === "/programdetail") {
        title = "Technical Results";
      }
      if (this.getCurrentPage === "/orderdetail") {
        title = "Order Transport Pay";
      }
      if (this.getCurrentPage === "/actiondetail") {
        title = "Action Detail";
      }
      if (this.getCurrentPage === "/plandetail") {
        title = "Business Plan";
      }
      if (this.getCurrentPage === "/planlist") {
        title = "Plan";
      }
      if (this.getCurrentPage === "/workdetail") {
        title = "Plan and Execute";
      }
      if (this.getCurrentPage === "/workrequestdetail") {
        title = "Plan and Execute";
      }
      if (this.getCurrentPage === "/workcalldetail") {
        title = "Plan and Execute";
      }
      if (this.getCurrentPage === "/calldetail") {
        title = "Plan and Execute";
      }
      if (this.getCurrentPage === "/worktooldetail") {
        title = "Execution and Results";
      }
      if (this.getCurrentPage === "/maintplandetail") {
        title = "Plan Preparation";
      }
      if (this.getCurrentPage === "/riskdetail") {
        title = "Risk Assessment";
      }
      if (this.getCurrentPage === "/hazarddetail") {
        title = "Hazard Detail";
      }
      if (this.getCurrentPage === "/engineeringdetail") {
        title = "Technical";
      }
      if (this.getCurrentPage === "/companydashsafety") {
        title = "Health and Safety";
      }
      if (this.getCurrentPage === "/companydashtechnical") {
        title = "Technical Mangement";
      }
      if (this.getCurrentPage === "/companydashbusiness") {
        title = "Business Operations";
      }
      if (this.getCurrentPage === "/facilitydashoperations") {
        title = "Plant Operations";
      }
      if (this.getCurrentPage === "/facilitydashmaintenance") {
        title = "Maintenance Systems";
      }
      if (this.getCurrentPage === "/facilitydashenginerring") {
        title = "Management of Change";
      }
      return title;
    }
  }
};
</script>
